import { Pagination } from 'swiper';
import { SwiperSlide, Swiper } from 'swiper/react';
import Image from "next/image";
import { imageLoader } from 'functions/imageLoader';
import { useRouter } from 'next/router';
import { useMemo } from 'react';


interface ProductCardMobileSwiperProps {
  cardImages: false | string[];
  title: string;
}

function ProductCardMobileSwiper({ cardImages, title }: ProductCardMobileSwiperProps) {
  if (!cardImages) {
    return null;
  }

  const router = useRouter();
  const isImageContain = useMemo(() => {
    return title.includes('Spex Glasses') || title.includes('Flex Accessory Clip') || router.asPath.includes('eye-care');
  }, [title, router.asPath]);

  return (
    <div className={`relative w-full ${isImageContain ? 'h-[350px]' : 'h-[234px]'} smx:${isImageContain ? 'h-[350px]' : 'h-[234px]'}`}>
      {cardImages && (
        <Swiper modules={[Pagination]} pagination>
          <SwiperSlide>
            <div className={`relative w-full ${isImageContain ? 'h-[350px]' : 'h-[234px]'} smx:${isImageContain ? 'h-[350px]' : 'h-[234px]'}`}>
              <Image
                quality={90}
                fill
                style={{
                  objectFit: "cover",
                }}
                sizes="414px"
                // priority={data.prio}
                loader={imageLoader}
                src={cardImages[0]}
                alt={title}
              />
            </div>
          </SwiperSlide>
          {cardImages[1] && (
            <SwiperSlide>
              <div className="relative h-[234px] w-full smx:h-[234px]">
                <Image
                  quality={90}
                  fill
                  style={{
                    objectFit: "cover",
                  }}
                  sizes="414px"
                  loader={imageLoader}
                  src={cardImages[1]}
                  alt={title}
                />
              </div>
            </SwiperSlide>
          )}
          {cardImages[2] && (
            <SwiperSlide>
              <div className="relative h-[234px] w-full smx:h-[234px]">
                <Image
                  quality={90}
                  fill
                  style={{
                    objectFit: "cover",
                  }}
                  sizes="414px"
                  loader={imageLoader}
                  //priority={data.prio}
                  src={cardImages[2]}
                  alt={title}
                />
              </div>
            </SwiperSlide>
          )}
        </Swiper>
      )}
    </div>
  );
};

export default ProductCardMobileSwiper;
